module.exports = __webpack_public_path__ + "static/media/Jess Corr.1645db2b.png";